<script src="./index.js"></script>
<style src="./style.scss" lang="scss" scoped/>
<template>

  <Modal :name="'forgottenPass'"
         :is-open="$store.state.utils.modals.forgottenPass"
         :title="$t('forgotten-password')"
  >
    <div>
      <div class="mb-3">
        <InputField label="E-mail" inputtype="email" v-model="form.email" :content="form.email"
                    :error="fieldErrors.includes('email')"/>
      </div>
      <div class="mb-2 mt-4">
        <Button @click="requestChangePassEmail()" :theme="'solid-green'" :size="'medium'" :text="$t('confirm-password-change-request')"/>
      </div>
    </div>
  </Modal>

</template>